import * as Yup from "yup";

export const AllocateMeterDeliveryMaterialsSchema = Yup.object().shape({
  allocations: Yup.array().of(
    Yup.object().shape({
      district: Yup.object({}).required("Required"),
      materials: Yup.array().of(
        Yup.object().shape({
          material: Yup.string().required("Required"),
          quantity: Yup.number().min(1, "Cannot be less than 1").required("Required"),
        })
      ),
    })
  ),
  notes: Yup.string(),
});

export const AllocateMeterDeliveryMaterialsInitialValues = {
  allocations: [] as {
    district: any;
    materials: {
      material: string,
      quantity: number,
    }[],
  }[],
  notes: "",
};
